import { Modal } from "react-bootstrap";
import PdfViewer from "./PdfView";
import "../scss/documentSliderModal.scss";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { imageExtensions, videoExtensions } from "../consts";
import { useState } from "react";

const DocumentSliderModal = ({
    show,
    onClose,
    documents = [],
    currentIndex,
    setCurrentIndex,
}) => {
    // show -> booleans value to show or hide the modal
    //onClose -> callback function which executes on close of the modal.
    //documents -> array of document objects which must includes id, docName, docURL.
    // here documents type should be either videos, pdfs or images
    // currentIndex -> indicates which document need to show, index of document
    // setCurrentIndex -> state setting variable

    const [isExpanded, setIsExpanded] = useState(false);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === documents.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? documents.length - 1 : prevIndex - 1
        );
    };

    return (
        <Modal show={show} onHide={onClose} size="lg" centered backdrop="static" fullscreen={isExpanded} style={{paddingLeft: "0px"}}>
            <Modal.Header>
                <Modal.Title className="slider-title">
                    {currentIndex+1 }. {documents[currentIndex].docName || documents[currentIndex].name}
                </Modal.Title>
                <span onClick={()=> {setIsExpanded(prev => !prev)}} className="custom-close">
                    <i class={`fa fa-${isExpanded? 'compress':'expand'} toggle-screen`} title={isExpanded?'Minimize':'Maximize'} aria-hidden="true"></i>
                </span>
                <span onClick={onClose} className="custom-close" title="Close">
                    &times;
                </span>
            </Modal.Header>

            <Modal.Body className="slider-body">
                <section>
                    <i
                        className={`fa fa-angle-left slide-arrow left-slide ${currentIndex === 0 ? "disable" : ""
                            }`}
                        onClick={prevSlide}
                        title="Previous"
                    ></i>

                    <div className="document">
                        {documents[currentIndex]?.fileType?.toLowerCase() === "pdf" ? (
                            <PdfViewer docUrl={documents[currentIndex].docURL} className='pdf-viewer1'/>
                        ) : videoExtensions.includes(
                            documents[currentIndex]?.fileType?.toLowerCase()
                        ) ? (
                            <div className="videos">
                                <video className="video" 
                                key={documents[currentIndex].docURL}
                                controls disablePictureInPicture>
                                    <source
                                        src={documents[currentIndex].docURL}
                                        type="video/mp4"
                                    />
                                </video>
                            </div>
                        ) : imageExtensions.includes(
                            documents[currentIndex]?.fileType?.toLowerCase()
                        ) ? (
                            <div className="images">
                                <ReactPanZoom
                                    image={documents[currentIndex].docURL}
                                    alt={documents[currentIndex].docName}
                                />
                            </div>
                        ):(<div className="d-flex align-items-center justify-content-center h-100">
                            <div className="text-center">
                                <h4>No Preview Available</h4>
                                <p>It looks like this file doesn't have a preview we can show</p>
                                <div
                                    className="btn btn-success mt-4 mb-0 px-4"
                                    onClick={() => {
                                        window.open(documents[currentIndex].docURL, '_blank');
                                    }}
                                >
                                    <i className= "fa fa-arrow-down me-2"></i>
                                    Download Document
                                </div>
                            </div>
                        </div>)
                        }
                    </div>

                    <i
                        className={`fa fa-angle-right slide-arrow right-slide ${currentIndex === documents.length - 1 ? "disable" : ""
                            }`}
                        onClick={nextSlide}
                        title = 'Next'
                    ></i>
                </section>
            </Modal.Body>
        </Modal>
    );
};

export default DocumentSliderModal;
